import { createSelector } from 'reselect';
const routerStateSelector = state => state.router;
export const makeGetPathname = () => createSelector(routerStateSelector, (routerState) => routerState.location.pathname);
export const makeGetLocationHash = () => createSelector(routerStateSelector, (routerState) => routerState.location.hash);
export const makeGetQueryParamPage = () => {
    return createSelector(routerStateSelector, (state) => { var _a; return parseInt((_a = state.location.query) === null || _a === void 0 ? void 0 : _a.page, 10) || 0; });
};
export const makeGetQueryParamProfileEdit = () => {
    return createSelector(routerStateSelector, (state) => { var _a; return (_a = state.location.query) === null || _a === void 0 ? void 0 : _a.profileEdit; });
};
